import graphql from "babel-plugin-relay/macro";

export const AdoptedSystemDocumentTemplatesQuery = graphql`
  query AdoptedSystemDocumentTemplatesQuery($sort: String) {
    adoptedSystemDocumentTemplates(sort: $sort) {
      adoptedSystemDocumentTemplates {
        totalCount
        edges {
          node {
            pk
            name
            total
            adopted
          }
        }
      }
      error {
        statusCode
      }
    }
  }
`;

export default AdoptedSystemDocumentTemplatesQuery;
